module.exports = __webpack_public_path__ + "img/Bonus_Avans.fe3dcd51.svg";